// extracted by css-extract-rspack-plugin
export default {"requirements":"src-shared-components-PasswordRequirements-PasswordRequirements-module__requirements-ldPNI8","rule":"src-shared-components-PasswordRequirements-PasswordRequirements-module__rule-jta0fG","icon":"src-shared-components-PasswordRequirements-PasswordRequirements-module__icon-fdRucE","dot":"src-shared-components-PasswordRequirements-PasswordRequirements-module__dot-XJBX5Z","ruleMet":"src-shared-components-PasswordRequirements-PasswordRequirements-module__ruleMet-R8n8wD"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"requirements\":\"src-shared-components-PasswordRequirements-PasswordRequirements-module__requirements-ldPNI8\",\"rule\":\"src-shared-components-PasswordRequirements-PasswordRequirements-module__rule-jta0fG\",\"icon\":\"src-shared-components-PasswordRequirements-PasswordRequirements-module__icon-fdRucE\",\"dot\":\"src-shared-components-PasswordRequirements-PasswordRequirements-module__dot-XJBX5Z\",\"ruleMet\":\"src-shared-components-PasswordRequirements-PasswordRequirements-module__ruleMet-R8n8wD\"}";
        // 1793875576513
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  